export const toolShowcase = {
  it: {
    title: "Stack Tecnologico e Filosofia Operativa",
    competencies: {
      title: "Competenze Chiave",
      items: [
        { icon: "Brain", label: "Sviluppo & Automazione: React · Node.js · Supabase · n8n · TypeScript" },
        { icon: "Cloud", label: "Cloud & Integrazioni: Azure App Service · REST API · WhatsApp Business" },
        { icon: "Database", label: "CRM & Dati: Supabase CRM · Google Business API" },
        { icon: "Bot", label: "AI & Automation: OpenAI API · Automazioni agentiche · Workflow intelligenti" },
        { icon: "Sparkles", label: "Soft Skills: Analisi processi · Comunicazione PMI · Project Design · Innovazione" }
      ]
    },
    impact: {
      title: "Impatto Quantificabile sul Business",
      items: [
        { value: "20+", label: "Progetti di digitalizzazione completati (2023-2025)" },
        { value: "-40%", label: "Riduzione media dei tempi di gestione clienti" },
        { value: "+60%", label: "Aumento dei contatti qualificati (caso studio AV Infissi)" },
        { value: "€230k+", label: "Opportunità di ricavo scoperte (analisi BI farmaceutica)" }
      ],
      note: "// DATI REALI DA SISTEMI IN PRODUZIONE"
    },
    badge: "ARCHITETTURA CORE",
    philosophy: {
      title: "La Mia Filosofia: Architettura per la Crescita",
      paragraphs: [
        "L'intelligenza artificiale non è più una tecnologia d'élite: è la nuova infrastruttura di business. Le PMI non hanno bisogno di un altro software complicato, ma di un sistema che lavori veramente per loro.",
        "Il mio modello non è un progetto 'una tantum', ma una partnership per la crescita continua.",
        "Offro un ecosistema digitale completo—progettato per integrarsi e scalare—a fronte di un canone chiaro. L'obiettivo non è un costo fisso, ma un vantaggio operativo misurabile."
      ],
      bullets: [
        "Sito web intelligente ottimizzato per essere trovato.",
        "WhatsApp automatizzato che risponde e qualifica 24/7.",
        "CRM operativo per gestire l'intero funnel di vendita.",
        "Dashboard e report per decisioni basate sui dati."
      ]
    }
  },
  en: {
    title: "Technology Stack & Operating Philosophy",
    competencies: {
      title: "Core Competencies",
      items: [
        { icon: "Brain", label: "Development & Automation: React · Node.js · Supabase · n8n · TypeScript" },
        { icon: "Cloud", label: "Cloud & Integrations: Azure App Service · REST APIs · WhatsApp Business" },
        { icon: "Database", label: "CRM & Data: Supabase CRM · Google Business API" },
        { icon: "Bot", label: "AI & Automation: OpenAI API · Agentic automations · Intelligent workflows" },
        { icon: "Sparkles", label: "Soft Skills: Process analysis · SME communication · Project Design · Innovation" }
      ]
    },
    impact: {
      title: "Quantifiable Business Impact",
      items: [
        { value: "20+", label: "Digitization projects completed (2023-2025)" },
        { value: "-40%", label: "Average reduction in client handling time" },
        { value: "+60%", label: "Increase in qualified leads (AV Infissi case study)" },
        { value: "€230k+", label: "Untapped revenue opportunities discovered (pharma BI analysis)" }
      ],
      note: "// REAL-WORLD DATA FROM PRODUCTION SYSTEMS"
    },
    badge: "CORE_ARCHITECTURE",
    philosophy: {
      title: "My Philosophy: Architecture for Growth",
      paragraphs: [
        "Artificial intelligence is no longer an elite technology: it is the new business infrastructure. SMEs don't need another complicated piece of software; they need a system that truly works for them.",
        "My model is not a 'one-off project,' but a partnership for continuous growth.",
        "I provide a complete digital ecosystem—designed to integrate and scale—for a clear fee. The goal isn't a fixed cost, but a measurable operational advantage."
      ],
      bullets: [
        "Intelligent website optimized to be found.",
        "Automated WhatsApp that responds and qualifies 24/7.",
        "Operational CRM to manage the entire sales funnel.",
        "Dashboards and reports for data-driven decisions."
      ]
    }
  }
};
